import { BoxProps, HeadingProps } from '@chakra-ui/react';

export const entityBoxStyle: BoxProps['style'] = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2em',
  width: '100%',
  borderWidth: '1px',
  padding: '2rem',
};

export const entityNameHeadingProps: HeadingProps = {
  variant: 'h3',
  fontSize: '24px',
  marginBottom: '1em',
};

export const entitySubPropertyHeadingProps: HeadingProps = {
  variant: 'h4',
  size: 'md',
};
